import "trumbowyg"
import "trumbowyg/dist/trumbowyg.min.js"
import "trumbowyg/dist/plugins/cleanpaste/trumbowyg.cleanpaste.min.js"

import "./plugins/trumbowyg.allowtagsfrompaste.js"
import "./plugins/trumbowyg.figcaption.js"
import "./plugins/trumbowyg.requiredalt.js"

document.addEventListener('turbo:load', () => {
  $('#content').trumbowyg({
    svgPath: '/images/icons-trumbowyg.svg',
    resetCss: false,
    imageWidthModalEdit: true,
    linkTargets: ['_blank'],
    semantic: {
      'div': 'div' // Editor does nothing on div tags now
    },
    btnsDef: {
      RealButtons: {
        title: '💜',
        hasIcon: false,
        dropdown: ['figcaption'],
      }
    },
    btns: [
      ['viewHTML'],
      ['undo', 'redo'], // Only supported in Blink browsers
      ['formatting'],
      ['strong', 'em', 'del'],
      ['superscript', 'subscript'],
      ['link'],
      ['insertImage'],
      ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
      ['unorderedList', 'orderedList'],
      ['horizontalRule'],
      ['removeformat'],
      ['RealButtons'],
      ['fullscreen'],
    ],
    plugins: {
      figcaption: {
        serverPath: '/api/uploads',
        fileFieldName: 'file'
      },
      allowTagsFromPaste: {
        allowedTags: [ 'a', 'em', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr', 'br', 'strike', 'sup', 'sub', 'img', 'i', 'small', 'strong', 'u', 'p', 'li', 'ol']
      }
    }
  });

  $('#content').on('tbwchange tbwblur tbwpaste', function () {
    const sites = document.getElementById('all_sites')
    if(!sites) return

    const allowedDomains = sites.value
    const editor = $(this)
      .closest('.trumbowyg-box')
      .find('.trumbowyg-editor');

    editor.find('a[target="_blank"]').each(function () {
      const $link = $(this);
      const href = $link.attr('href');

      if (!href) return;

      const url = new URL(href, globalThis.location.origin);
      const hostname = url.hostname.replace(/^www\./, '');;

      let relValues = ($link.attr('rel') || '')
        .split(' ')
        .filter(Boolean);

      if (!relValues.includes('noopener')) relValues.push('noopener');
      if (!relValues.includes('noreferrer')) relValues.push('noreferrer');

      if (allowedDomains.includes(hostname)) {
        relValues = relValues.filter(value => value !== 'nofollow');
      } else if (!relValues.includes('nofollow')) {
        relValues.push('nofollow');
      }

      $link.attr('rel', relValues.join(' '));
    });
  });
});
